import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=17bfee7a&scoped=true"
import script from "./MessageItem.vue?vue&type=script&lang=ts"
export * from "./MessageItem.vue?vue&type=script&lang=ts"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=17bfee7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bfee7a",
  null
  
)

export default component.exports